// src/components/common/Toast.jsx
import React, { useState, useEffect } from 'react';

let toastFn = null;

export const showToast = (message, type = 'info') => {
  if (toastFn) toastFn(message, type);
};

const Toast = () => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [type, setType] = useState('info');
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    toastFn = (msg, t = 'info') => {
      setMessage(msg);
      setType(t);
      setVisible(true);
      if (timer) clearTimeout(timer);
      const newTimer = setTimeout(() => setVisible(false), 3200);
      setTimer(newTimer);
    };
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [timer]);

  if (!visible) return null;

  const bgColor = type === 'error' ? '#7a2e2e' : '#0c1712';

  return (
    <div className="toast show" style={{ background: bgColor }}>
      {message}
    </div>
  );
};

export default Toast;